<div [ngClass]="[styleFloatLabel, numberClassContainer]">
    <label
        [ngClass]="numberClassContainer ? ' sera-input-number-label-left-align' : ''"
        class="sera-input-number-label"
        *ngIf="label"
        for="{{ inputId }}"
        >{{ label }}</label
    >
    <i
        *ngIf="icon"
        [ngClass]="icon"></i>
    <p-inputNumber
        [attr.sera-read-only]="readOnly ? '' : null"
        [minFractionDigits]="minFractionDigits"
        [maxFractionDigits]="maxFractionDigits"
        [inputId]="inputId"
        [name]="name"
        [placeholder]="placeholder"
        [mode]="mode"
        [format]="format"
        [showButtons]="showButtons"
        [showClear]="showClear"
        [allowEmpty]="allowEmpty"
        [required]="required"
        [disabled]="isDisabled"
        [readonly]="readOnly"
        [style]="style"
        [styleClass]="autoWidth ? styleClass + ' p-sera-inputNumber-auto-width' : styleClass"
        [ngClass]="autoWidth ? ' p-sera-inputNumber-auto-width' : ''"
        [inputStyleClass]="icon ? 'p-sera-input-number ' + inputStyleClass : inputStyleClass"
        [inputStyle]="inputStyle"
        [min]="min"
        [max]="max"
        [maxlength]="maxlength"
        [ngModel]="numberPipeFractionDigits && value % 1 !== 0 ? (value | number : '1.0-' + numberPipeFractionDigits) : value"
        [ngModelOptions]="numberPipeFractionDigits ? { updateOn: 'blur' } : {}"
        (ngModelChange)="value = $event"
        (onInput)="emitInputNumberChange(value)"
        (onFocus)="emitInputNumberFocus(value)"
        (onBlur)="emitInputNumberBlur(value)"
        (onClear)="emitInputNumberClear(value)">
    </p-inputNumber>
</div>
